module.exports = __webpack_public_path__ + "static/media/dangkythongbaophatnguoi.6c22ed74.jpg";